import { render, staticRenderFns } from "./Snags.vue?vue&type=template&id=3e71879a&scoped=true"
import script from "./Snags.vue?vue&type=script&lang=js"
export * from "./Snags.vue?vue&type=script&lang=js"
import style0 from "./Snags.vue?vue&type=style&index=0&id=3e71879a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71879a",
  null
  
)

export default component.exports